import {
  ComplianceControl,
  ComplianceControlProps,
} from "~/pages/compliance/Control/ComplianceControl";

const FrameworkControlEntryPage = ({ space }: ComplianceControlProps) => {
  return <ComplianceControl {...{ space }} />;
};

export default FrameworkControlEntryPage;
